import * as React from "react";
import { forwardRef } from "react";
const SvgNotification = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 4, fill: "currentColor" }));
const ForwardRef = forwardRef(SvgNotification);
export default ForwardRef;
